import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=8e6b72c4&scoped=true&"
import script from "./NavigationTabs.vue?vue&type=script&lang=js&"
export * from "./NavigationTabs.vue?vue&type=script&lang=js&"
import style0 from "./NavigationTabs.vue?vue&type=style&index=0&id=8e6b72c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6b72c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
